/**
 * 判断各种设备的方法
 */

const UA = (window as any).navigator.userAgent.toLowerCase();

const isWindows = () => {
    return /windows/i.test(UA);
};

// 判断是否为iOS设备
const isIOS = () => {
    // 使用正则表达式判断UA中是否包含iphone、ipad或ipod
    return /iphone|ipad|ipod/i.test(UA);
};

const iphone = () => {
    return /iphone/i.test(UA);
};

const ipod = () => {
    return /ipod/i.test(UA);
};

const windowsPhone = () => {
    return /windows phone/i.test(UA);
};

const blackberryPhone = () => {
    return /blackberry/i.test(UA);
};

const fxosPhone = () => {
    return /mobile/i.test(UA) && /firefox/i.test(UA);
};

const meego = () => {
    return /meego/i.test(UA);
};

const android = () => {
    return /android/i.test(UA);
};

const androidPhone = () => {
    return android() && /mobile/i.test(UA);
};

const mobile = () => {
    return (
        androidPhone() ||
        iphone() ||
        ipod() ||
        windowsPhone() ||
        blackberryPhone() ||
        fxosPhone() ||
        meego()
    );
};

const isWechat = () => {
    return /micromessenger/i.test(UA);
};

export default {
    isAndroid: android,
    isIOS: isIOS,
    isWechat: isWechat,
    isWindows: isWindows,
    isMobile: mobile,
};
